import * as Preact from "preact"
import Navigation from "@frog/source/models/Navigation.js"

export default class TestWidget {
    render() {
        if(window?.frog?.test?.results == undefined) {
            return (
                <div class="Test Widget">
                    <div class="Label">Tests</div>
                    <div class="Value">...</div>
                </div>
            )
        }
        if(window?.frog?.test?.results?.badcount > 0) {
            return (
                <div class="Test Widget" status={"bad"} onClick={this.onClick}>
                    <div class="Label">Tests</div>
                    <div class="Value">{window.frog.test.results.badcount} / {window.frog.test.results.count}</div>
                </div>
            )
        } else {
            return (
                <div class="Test Widget" status={"good"} onClick={this.onClick}>
                    <div class="Label">Tests</div>
                    <div class="Value">{window.frog.test.results.count}</div>
                </div>
            )
        }
    }
    onClick(event) {
        Navigation.state.devscreen = "TestListScreen" // TODO: move this into method, not data change?
    }
}
